import React from 'react';

import { BoostSheetTable, SheetTable } from '@packages/types';

import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useBoostDetailsStore } from '@store';
import { sluggify, testProps } from '@utils';

export interface SheetTableListProps {
  item: BoostSheetTable;
}

export const SheetTableList: React.FC<SheetTableListProps> = ({ item }) => {
  const shouldShowDisclaimer = useBoostDetailsStore(state => state?.boostDetails?.code === 'OMD');
  return (
    <div className="flex flex-col gap-y-s16">
      <Text variant="h4-24/sb" {...testProps(sluggify(item.title))}>
        {item.title}
      </Text>
      {item.tables.length > 0 &&
        item.tables.map((it, index) => (
          <div key={`${it.columnNames.title}${index}`}>
            <SheetTableListItem table={it} />
          </div>
        ))}
      <Text className="my-4" variant="body-16/r" {...testProps('medical-dental-disclaimer')}>
        {shouldShowDisclaimer && i18n.t('myQuote.medicalAndDentalDisclaimer')}
      </Text>
    </div>
  );
};
export function SheetTableListItem({ table }: { table: SheetTable }) {
  return (
    <div>
      <Text variant="subTitle-20/sb" className="pb-s16" {...testProps(table.columnNames.title)}>
        {table.columnNames.title}
      </Text>
      {table.items.length > 0 &&
        table.items.map((it, index) => {
          return (
            <TableRow
              child={it.child}
              title={it.title}
              value={it.value}
              key={`${it.title}${it.value}${index}`}
            />
          );
        })}
    </div>
  );
}

type TableRowProps = {
  child?: { title: string; value: string };
  title: string;
  value: string;
  hasBottomBorder?: boolean;
};

function TableRow({ title, value, hasBottomBorder = true, child }: TableRowProps) {
  const childRow = child ? (
    <div className="flex flex-row justify-between pb-4">
      <Text
        variant="body-16/r"
        className="ml-5 italic"
        {...testProps(sluggify(child.title))}>{`• ${child.title}`}</Text>
      <Text variant="body-16/r" {...testProps(`${sluggify(child.title)}-description`)}>
        {child.value}
      </Text>
    </div>
  ) : null;

  return (
    <div className={hasBottomBorder ? 'border-gray border-b-[1px] ' : ''}>
      <div className="flex flex-row justify-between py-s8">
        <Text variant="body-16/r" {...testProps(sluggify(title))}>
          {title}
        </Text>
        <Text variant="body-16/sb" {...testProps(`${sluggify(title)}-description`)}>
          {value}
        </Text>
      </div>
      {childRow}
    </div>
  );
}
